import {GET_IMAGE_LIST, UPDATE_HOUSE_BASIC_DATA} from "./releaseRentalHousing";

export const RECORD_CHANGE_ALLOWRERENT = 'RECORD/RECORD_CHANGE_ALLOWRERENT';
export const RECORD_CHANGE_RERENT = 'RECORD/RECORD_CHANGE_RERENT';
export const RECORD_CHANGE_ROLE = 'RECORD/RECORD_CHANGE_ROLE';
export const UPDATE_DATA = 'RECORD/UPDATE_DATA';
export const UPDATE_HOUSE_DATA = 'RECORD/UPDATE_HOUSE_DATA';
export const UPDATE_RENT_DATA = 'RECORD/UPDATE_RENT_DATA';
export const UPDATE_TENANT = 'RECORD/UPDATE_TENANT';
export const ADD_TENANT = 'RECORD/ADD_TENANT';
export const DELETE_TENANT = 'RECORD/DELETE_TENANT';



const initialState = {
    index:1,
    pageSize:2,
    role:1,
    step:1,
    totalStep:2,
    tenantCount:2,
    contractDetail:{},
    idTypet:"",
    dataMsg:{},
    printStatus:false,
    imgSrc:"//breaa-pic-offline-1255419371.picsh.myqcloud.com",
    auditList:[],
    audit:{},//产权列表

    houseBasicData:{
        auditId:'',//产权id

        houseType:"1",//房屋类型
        houseArea:"1",
        houseDirection:"1",//房屋朝向
        useType:"1",
        startLevel:"1",
        endLevel:"1",
        levelNum:"1",
        buildingType:"1",
        buildYear:"1",
        decorationType:"1",
        warmType:"1",
        equValue:"1",
        rooms :"1",
        living:"1",
        toilet:"1",
        kitchen:"1",
        contractImg:[  {"url":"https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"}],
        nullArr:[]
    },
    printData:{},

//step2
    rentData:{
        //
        contractNo:"",
        rentPrice:"",
        mortgageMonth:"",//押
        payMonth:"",
        startDate:"",
        endDate:"",
        totalMoney:"",
        maxRentPeopleCount:'',
        rentPeopleCount:'',
        allowRerent:0,
        allowMultiple:0,
        rerent:1,
        rentPeopleName:"",
        rentPeoplePhone:"",
        rentPeopleIdType:"",
        rentPeopleIdTypeNum:"",
        rentPeopleImg:"",
        contractImg:[],
        nullArr:[]
    },
    imgViewData1:[
    {src: '/static/pages/layout/1.png', alt: ''},
    {src: '/static/pages/layout/2.jpg', alt: ''},
    {src: '/static/pages/layout/3.png', alt: ''},
],

    tenantList:[
        {name:"1",phone:"",idType:"",idTypeNum:"",education:"",province:"",nationality:"",birthdate:"",hasAgent:0,agentName:"",agentPhone:"",agentIdType:"",agentIdTypeNum:"",contractImg:[]},
        {name:"2",phone:"",idType:"",idTypeNum:"",education:"",province:"",nationality:"",birthdate:"",hasAgent:0,agentName:"",agentPhone:"",agentIdType:"",agentIdTypeNum:"",contractImg:[]},
    ],

    calloffMsg:{},

};


const houseDataReducer =  (houseBasicData=0, action)=>{
    switch (action.type) {
        case UPDATE_HOUSE_DATA:
            return {
                ...houseBasicData,
                [action.subType]:action.data
            }
        default:
            return [...houseBasicData]
    }
}
const rentDataReducer =  (rentData=0, action)=>{
    switch (action.type) {
        case UPDATE_RENT_DATA:
            return {
                ...rentData,
                [action.subType]:action.data
            }
        default:
            return [...rentData]
    }
}
const tenantDataReducer =  (tenant=0, action)=>{

   let t=tenant[action.k];
   t[action.subType]=action.data;
    tenant[action .k]=t;
    return [...tenant];

}
const addtenantDataReducer =  (tenant=0, action)=>{
    let tenants=tenant;
  let t= {name:"1",phone:"",idType:"",idTypeNum:"",education:"",province:"",nationality:"",birthdate:"",hasAgent:0,agentName:"",agentPhone:"",agentIdType:"",agentIdTypeNum:"",contractImg:[]};
    tenant.push(t);
    return [...tenant];

}

const deleteTenantDataReducer =  (tenant=0, action)=>{

    tenant.splice(action.k,1);

    return  [...tenant];

}
export default (state = initialState, action) => {

    switch (action.type) {
        case RECORD_CHANGE_ALLOWRERENT:
            return {
                ...state,
                allowRerent: action.data
            };
        case RECORD_CHANGE_RERENT:
            return {
                ...state,
                rerent: action.data
            };
        case RECORD_CHANGE_ROLE:
            return {
                ...state,
                role: action.data
            };
        case UPDATE_DATA:
            return {
                ...state,
                [action.subType]: action.data
            };
        case UPDATE_TENANT:
            return {
                ...state,
                 tenantList: tenantDataReducer(state.tenantList,action)

            };
        case UPDATE_HOUSE_DATA:
            return {
                ...state,
                houseBasicData : houseDataReducer(state.houseBasicData, action),

            };
        case UPDATE_RENT_DATA:
            return {
                ...state,
                rentData : rentDataReducer(state.rentData, action),

            };
        case ADD_TENANT:
            return {
                ...state,
                tenantList: addtenantDataReducer(state.tenantList,action)

            };
        case DELETE_TENANT:
            return {
                ...state,
                tenantList: deleteTenantDataReducer(state.tenantList,action)

            };
        default:
            return state;
    }
}


export const dispatch_func = {
    update_data : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATE_DATA,
                subType:type,
                data: data
        });
        };
    },
    update_rent_data : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATE_RENT_DATA,
                subType:type,
                data: data
            });
        };
    },
    update_house_data : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATE_HOUSE_DATA,
                subType:type,
                data: data
            });
        };
    },update_tenant : (data,type,k) => {
        return dispatch => {
            dispatch({
                type: UPDATE_TENANT,
                subType:type,
                data: data,
                k:k
            });
        };
    },
    changeAllowRerent : (data) => {
        return dispatch => {
            dispatch({
                type: RECORD_CHANGE_ALLOWRERENT,
                data:data
            });
        }
    },
    changeRerent : (data) => {
        return dispatch => {
            dispatch({
                type: RECORD_CHANGE_RERENT,
                data:data
            });
        }
    },
    changeRole: (data) => {
        return dispatch => {
            dispatch({
                type: RECORD_CHANGE_ROLE,
                data:data
            });
        }
    },
    addTenant: (data) => {
        return dispatch => {
            dispatch({
                type: ADD_TENANT,
                data:data
            });
        }
    },
    deleteTenant: (k) => {
        return dispatch => {
            dispatch({
                type: DELETE_TENANT,
                k:k
            });
        }
    },


};


// WEBPACK FOOTER //
// ./src/modules/viewContract.js